import React from "react";
import moment from "moment";
import { Route, Redirect, withRouter } from "react-router-dom";

const SearchContext = React.createContext();

class SearchProvider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countries: [
                {
                    id: "",
                    iso: "",
                    name: "",
                    nicename: "",
                    iso3: "",
                    numcode: 0,
                    phonecode: 0,
                    active: 0,
                },
            ],
            activeCountries: [
                {
                    id: "",
                    iso: "",
                    name: "",
                    nicename: "",
                    iso3: "",
                    numcode: 0,
                    phonecode: 0,
                    active: 0,
                },
            ],
            countriesNice: [],
            countrySelected: null,
            startDate: moment(),
            endDate: moment().add(7, "days"),
            numGuests: "1",
            listingsVisible: false,
            results: [],
            // filters: [],
            // filterOptions: [],
            city: "None",
            placeSelected: {},
            userSelected: {},
            seeking: "stay",
        };

        this.setResults = this.setResults.bind(this);
        this.setSeeking = this.setSeeking.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.setCountries = this.setCountries.bind(this);
        this.setDates = this.setDates.bind(this);
        this.setGuests = this.setGuests.bind(this);
        this.showListings = this.showListings.bind(this);
        this.setCity = this.setCity.bind(this);
        this.setPlaceSelected = this.setPlaceSelected.bind(this);
        this.setUserSelected = this.setUserSelected.bind(this);
    }

    componentDidMount() {
        // Fetch the country list from the API if we haven't got it already
        if (this.state.countries.length <= 1) {
            axios
                .get("/api/countries-list")
                .then((response) => {
                    this.setState({
                        countries: response.data,
                        activeCountries: response.data.filter(
                            (c) => c.active === 1 && c.fbc_core_users_count > 0
                        ),
                        countriesNice: response.data.map((item) => {
                            return { value: item.id, label: item.nicename };
                        }),
                    });
                })
                .catch(function (error) {
                    console.log("Request failure: ", error);
                });
        }
    }

    setCity(data) {
        this.setState({ city: data });
    }

    setResults(data) {
        this.setState({ results: data });
    }

    setSeeking(data) {
        this.setState({ seeking: data });
    }

    setSelected(data) {
        this.setState({ countrySelected: data });
    }

    setCountries(data) {
        this.setState({ countries: data });
    }

    setDates(sDate, eDate) {
        this.setState({ startDate: sDate, endDate: eDate });
    }

    setGuests(g) {
        this.setState({ numGuests: g });
    }

    showListings() {
        this.setState({ listingsVisible: true });
    }

    setPlaceSelected(p) {
        this.setState({ placeSelected: p });
    }

    setUserSelected(u) {
        this.setState({ userSelected: u });
    }

    render() {
        return (
            <SearchContext.Provider
                value={{
                    ...this.state,
                    setResults: this.setResults,
                    setSeeking: this.setSeeking,
                    setSelected: this.setSelected,
                    setCountries: this.setCountries,
                    setDates: this.setDates,
                    setGuests: this.setGuests,
                    showListings: this.showListings,
                    // setFilters: this.setFilters,
                    setCity: this.setCity,
                    setPlaceSelected: this.setPlaceSelected,
                    setUserSelected: this.setUserSelected,
                }}
            >
                {this.props.children}
            </SearchContext.Provider>
        );
    }
}

const SearchConsumer = SearchContext.Consumer;
// use the withRouter HOC which adds the history prop
SearchProvider = withRouter(SearchProvider);

export { SearchProvider, SearchConsumer };

// Provide access to SearchContext via HOC
// This function takes a component...
export function withSearch(WrappedComponent) {
    // ...and returns another component...
    return function SearchComponent(props) {
        // ... and renders the wrapped component with the  context
        // Notice that we pass through any additional props as well
        return (
            <SearchContext.Consumer>
                {(search) => <WrappedComponent {...props} search={search} />}
            </SearchContext.Consumer>
        );
    };
}
